export default {
  'agenda_id': 'getSchedules',
  'date': 'getSchedules'
}



// WEBPACK FOOTER //
// ./src/app/professional/dashboard/professional/gadget/components/active-agenda/resources/watch.js